
import { defineComponent, ref } from 'vue'
import Basic from './basic.vue'
import Profession from './profession.vue'
import { updateUserInfo } from '@/api/profile'
import { UserInfo } from '@/api/type'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    isEdit: {
      type: Boolean,
      required: true,
    },
    userInfoList: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { Basic, Profession },
  setup(props, { emit }) {
    const { t } = useI18n()
    const outerVisible = ref<boolean>(true)
    const innerVisible = ref<boolean>(false)
    const tabPosition = ref<string>('left')
    const activeName = ref<string>('basic')

    const close = () => {
      emit('close')
    }
    const save = async () => {
      const res = await updateUserInfo(props.userInfoList as UserInfo)
      if (res.status === 200) {
        ElMessage({
          message: t('profile.updateSuccess'),
          type: 'success',
        })
        emit('updateSucess')
      }
    }
    const uploadSuccess = () => {
      emit('uploadSuccess')
    }

    return {
      outerVisible,
      innerVisible,
      close,
      save,
      tabPosition,
      activeName,
      uploadSuccess,
    }
  },
})
